import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import 'fontsource-roboto';

// Polyfill para process.env si no existe
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = {
    env: {
      NODE_ENV: 'development'
    }
  };
}

// También definir globalmente
if (typeof global === 'undefined') {
  window.global = window;
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => registrations.forEach((registration) => registration.unregister()))
      .catch((error) => console.warn('No se pudo desregistrar service worker:', error));

    if (window.caches) {
      window.caches.keys()
        .then((cacheNames) => Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName))))
        .catch((error) => console.warn('No se pudo limpiar cache de la aplicacion:', error));
    }
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
  ,
  document.getElementById('root')
);

// Cargar herramientas de prueba solo en desarrollo
if (process.env.NODE_ENV === 'development') {
  import('./test/TestRunner').then(() => {
    console.log('🧪 Herramientas de prueba cargadas. Escriba testResponsable.help() para ver comandos disponibles.');
  }).catch(err => {
    console.warn('No se pudieron cargar las herramientas de prueba:', err);
  });
}
